<template>
  <!-- 复习 之 图片选择 横向 -->
  <div class="image-selection-transversal review-questions-content">
    <div class="img-container">
      <em class="audio-play" v-if="isOn" @click="handlePauseClick"></em>
      <img class="headimg" v-else-if="!isOn" src="@/assets/on.gif" />
    </div>
    <audio
      :src="selectState"
      ref="cur_play_audio2"
      autoplay
      @ended="handleCompleted"
      @play="handleComPlay"
    ></audio>
    <audio
      :src="listData.steps_sound"
      ref="cur_play_audio"
      autoplay
      @ended="handleEnded"
      @play="handlePlay"
    ></audio>
    <div class="question-box">
      <div class="questions-content transversal-content">
        <img class="questions-bg" src="@/assets/images/studyCenter/questions/p-bg.png" alt />
        <div class="list">
          <div
            class="item"
            :class="{'cur':curIndex==index}"
            @click="changeType(item,index)"
            v-for="(item, index) in listData.option"
            :key="index"
          >
            <img :src="item.medias_optionimg" alt />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      curIndex: null,
      isOn: true,
      selectState: "",
      timeDuration: null,
      timeNum: 0,
      issucceed: ""
    };
  },
  name: "ImageSelectionTransversal",
  props: ["list", "listData"],
  methods: {
    handlePauseClick(){
      this.$refs.cur_play_audio.play()
    },
    handleComPlay() {
      this.isOn = false;
    },
    handleCompleted() {
      this.$emit("changeType", {
        issucceed: this.issucceed,
        operatetime: this.timeNum
      });
      window.clearInterval(this.timeDuration);
      this.isOn = true;
    },
    handlePlay() {
      this.isOn = false;
    },
    handleEnded() {
      this.isOn = true;
    },
    getData() {
      // console.log("getData");
    },
    changeType(item, index) {
      if (this.isOn) {
        this.curIndex = index;
        const state = this.listData.steps_answer;
        if (state == item.medias_optionname) {
          // 答案正确
          // this.selectState = this.listData.audio_true_url;
          this.issucceed = 1;
          this.handleCompleted()
        } else {
          // 答案错误
          this.selectState = this.listData.audio_false_url;
          this.issucceed = 0;
        }
      } else {
        // console.log("还在播放");
      }
    }
  },
  created() {
    this.timeDuration = setInterval(() => {
      ++this.timeNum;
    }, 1000);
  },
  mounted() {
    // console.log(this.listData, "listDatalistData");
  }
};
</script>

<style lang="less">
  .img-container{
    // width: 40px;
    // height: 40px;    
    position: relative;
    img{
      position: absolute;
      top: 20px;
      right: 20px;
      width: 40px;
      height: 40px;
      display: block
    }
  }
</style>
